import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get deals 
export const getDeal = createAsyncThunk("deals/get-deals ", async (data) => {
    let path = null;
    console.log("data---->",data);
    if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
        path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-deals/${data.id}`;
    }
    else {
        path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-deals`;
    }
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${path}`, data, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log('dealresponse????????????',response)
        return response;
    } catch (error) {
        console.error('Error fetching deals - ', error);
        throw error;
    }
})



export const getClientDeal = createAsyncThunk("deals/client-deal ", async (data) => {
    let path = null;
    
    if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
        path = `${baseUrl}cleaningappfunctions/crm/app/v1/client-deal/${data.id}`;
    }
    else {
        path = `${baseUrl}cleaningappfunctions/crm/app/v1/client-deal`;
    }
    const token = localStorage.getItem("authToken")
    const body = {
        path: data.path,
    }
    try {
        const response = await axios.post(`${path}`, body, {
            headers: {
                "auth-token": token,
            }
        },);
        return response.data;
    } catch (error) {
        console.error('Error fetching client-deal - ', error);
        throw error;
    }
})


export const getDealReladedList = async (id) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-related-deal-list/${id}`, {
        headers: {
          "auth-token": token,
        }
      },)
    //   console.log("<<<<<<???????????????????DealsReduxresponse>>>>>>>>>>>>>",response)
      return response;
    } catch (error) {
      throw error
    }
  }

